import React from "react";
import escapeStringRegexp from "escape-string-regexp";

export const HighlightTokens = ({
  text = "",
  title = "",
  tokenLevels = [],
  qcEnabled = false,
}) => {
  if (!tokenLevels || tokenLevels.length === 0 || !qcEnabled) {
    return (
      <span>
        <span style={{ fontWeight: "bold" }}>
          {title !== "" && title + ": "}
        </span>{" "}
        {text}
      </span>
    );
  }
  let sanitizedTokens = tokenLevels.map((token) => escapeStringRegexp(token));
  const regex = new RegExp(`(${sanitizedTokens.join("|")})`, "gi");
  const parts = text.split(regex);
  return (
    <span>
      <span style={{ fontWeight: "bold" }}>{title !== "" && title + ": "}</span>
      {parts
        .filter((part) => part)
        .map((part, i) =>
          regex.test(part) ? (
            <mark
              key={i}
              style={{
                backgroundColor: "#D4FAFA",
                padding: "0px 4px",
                borderRadius: "3px",
                fontWeight: "500",
              }}
            >
              {part}
            </mark>
          ) : (
            <span key={i}>{part}</span>
          )
        )}
    </span>
  );
};
